import Vue from 'vue';
import VueSimpleRangeSlider from '../components/simpleRangeSlider.vue';

export default Vue.component('vueSimpleRangeSlider', VueSimpleRangeSlider);
